(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    justify-content: flex-start;\n    padding: 10px;\n    &:after {\n      display: none;\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex } from "../layout";
import { media } from "../../helpers/responsive";
var StyledStep = styled(Flex).withConfig({
  displayName: "Step__StyledStep",
  componentId: "sc-4xcvoc-0"
})(["display:flex;flex:1 0 0;justify-content:flex-start;align-items:center;color:#717171;", " ", " padding:0 8px;&:after{margin-left:16px;content:'';flex:1 0 0;height:2px;background-color:#eee;}", ""], function (props) {
  return props.done && 'color: #293440;';
}, function (props) {
  return props.active && " color: #5A338B;";
}, media.css.mobile.and('down')(_templateObject()));
var StepLabel = styled('div').withConfig({
  displayName: "Step__StepLabel",
  componentId: "sc-4xcvoc-1"
})(["display:flex;", ""], function (props) {
  return props.isClickable ? 'cursor: pointer;' : '';
});
var StepNumber = styled('div').withConfig({
  displayName: "Step__StepNumber",
  componentId: "sc-4xcvoc-2"
})(["display:flex;justify-content:center;align-items:center;padding-top:1px;font-size:14px;width:24px;height:24px;border-radius:100%;color:#fff;background-color:#717171;margin-right:8px;", " ", ""], function (props) {
  return props.done && 'background-color: #293440;';
}, function (props) {
  return props.active && 'background-color: #5A338B; ';
});
var StepTitle = styled('div').withConfig({
  displayName: "Step__StepTitle",
  componentId: "sc-4xcvoc-3"
})(["display:flex;flex:1 0 0;align-items:center;"]);

var Step = function Step(props) {
  var index = props.index,
      title = props.title,
      hideStepNumber = props.hideStepNumber,
      onClick = props.onClick,
      rest = _objectWithoutProperties(props, ["index", "title", "hideStepNumber", "onClick"]);

  var clickableProps = {
    isClickable: typeof onClick === 'function'
  };

  if (clickableProps.isClickable) {
    clickableProps.onClick = onClick;
    clickableProps.role = 'button';
  }

  return React.createElement(StyledStep, rest, React.createElement(StepLabel, clickableProps, hideStepNumber ? null : React.createElement(StepNumber, rest, index + 1), React.createElement(StepTitle, null, title)));
};

Step.defaultProps = {
  hideStepNumber: false
};
Step.propTypes = {
  active: PropTypes.bool,
  done: PropTypes.bool,
  title: PropTypes.string,
  onClick: PropTypes.func,
  hideStepNumber: PropTypes.bool
};
var _default = Step;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(StyledStep, "StyledStep", "/home/vsts/work/1/s/src/components/steps/Step.js");
  reactHotLoader.register(StepLabel, "StepLabel", "/home/vsts/work/1/s/src/components/steps/Step.js");
  reactHotLoader.register(StepNumber, "StepNumber", "/home/vsts/work/1/s/src/components/steps/Step.js");
  reactHotLoader.register(StepTitle, "StepTitle", "/home/vsts/work/1/s/src/components/steps/Step.js");
  reactHotLoader.register(Step, "Step", "/home/vsts/work/1/s/src/components/steps/Step.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/steps/Step.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();